module.exports = __webpack_public_path__ + "static/media/twitter.9bf0df4b.svg";